import { ArrowRight, Calendar, Newspaper } from "lucide-react";
import CTAButton from "Util/CTAButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const BlogCTA = () => {
  const lang = useSelector((state) => state.language.lang);
  const navigate = useNavigate();

  const text = {
    en: {
      title: "Need Career Guidance?",
      description:
        "Explore practical insights on career development, AI, startups, migration, and life in New Zealand. If you're looking for personalised guidance, we're here to help.",
      button: "Book a Consultation",
    },
    vi: {
      title: "Bạn Đang Cần Định Hướng Nghề Nghiệp?",
      description:
        "Khám phá những bài viết về hướng nghiệp, AI, khởi nghiệp, cuộc sống và hành trình hội nhập tại New Zealand. Nếu bạn cần tư vấn riêng, chúng tôi luôn sẵn sàng đồng hành.",
      button: "Đặt Lịch Tư Vấn",
    },
  };

  const t = text[lang];

  return (
    <section className="mt-28">
      <div
        className="
          relative
          overflow-hidden
          rounded-[36px]
          bg-gradient-to-b
          from-navy
          via-navy
          to-navy
          px-8
          py-14
          lg:px-16
          lg:py-16
          shadow-2xl max-w-7xl mx-3
        "
      >
        {/* Background glow */}
        <div className="absolute -right-32 -top-20 h-72 w-72 rounded-full bg-navy/20 blur-3xl" />

        <div className="relative grid lg:grid-cols-[1fr_auto] gap-10 items-center">
          {/* Left */}
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white mb-5">
              <Newspaper size={16} />
              Blog
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-neonYellow leading-tight">
              {t.title}
            </h2>

            <div className="w-20 h-1 bg-neonYellow rounded-full my-6" />

            <p className="text-white/80 text-lg leading-8">{t.description}</p>
          </div>

          {/* Right */}
          <div className="flex justify-start lg:justify-end">
            <CTAButton
              variant="primary"
              icon={Calendar}
              text={t.button}
              onClick={() => navigate("/achievers")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCTA;
